// extracted by mini-css-extract-plugin
export default {"ResetBtn":"ResetBtn_ResetBtn__0g9Qa"};